import React from 'react';
import Button from '@material-ui/core/Button';
import {store} from 'MainApp';
import moment from 'moment-timezone';
import CardBox from 'components/CardBox';
import Chip from '@material-ui/core/Chip';
import Switch from '@material-ui/core/Switch';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {Link} from 'react-router-dom'
import config from './config.js';
import CircularProgress from '@material-ui/core/CircularProgress';
import IntlMessages from 'util/IntlMessages';
import {connect} from 'react-redux';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import {
    RESEND_ACTIVE_LINK
} from 'constants/SafeeActionTypes';

import {
    SHOW_ERROR_MESSAGE
} from 'constants/B2ActionTypes';

import {
    processB2SecurityEvent
} from 'actions/B2App';

class SafeeApplyPromoCode extends React.Component {
    constructor(props) {
        super(props);

        let packages = [...this.props.datasources[this.props.beans[this.props.uiDefinition.offeringsDatasource].datasource].entityList.data[0].relationships['RevPackageNP'].data];
        let agreements = this.props.datasources[this.props.beans[this.props.uiDefinition.activeAgreementsDatasource].datasource].entityList.data;

        let pkg = null;

        for (let tempPkg of packages){
            if (pkg == null){
                pkg = tempPkg;
            }else if ((tempPkg.attributes.packageWeight.value) > (pkg.attributes.packageWeight.value)){
                pkg = tempPkg;
            }
        }

        let agreement = null;
        let anyOngoingSubscription=false;

        for (let custAgreement of agreements){
            if (this.validateAgreement(custAgreement)) {
                anyOngoingSubscription = true;
                if (custAgreement.attributes.packageName.value === pkg.attributes.packageName.value) {
                    agreement = custAgreement;
                    break
                }
            }else{
                if (custAgreement.attributes.packageName.value === pkg.attributes.packageName.value) {
                    break;
                }
            }
        }

        let options = pkg.relationships['RevPackageSubscriptionOption'].data;

        let highestWeight = null;
        let highestWeightedOption = null;

        for (let i = 0; i < options.length; i++) {
          if (highestWeight == null){
            highestWeight = this.getOptionWeight(options[i]);
            highestWeightedOption = options[i];
          }else{
            let newOptionWeight = this.getOptionWeight(options[i]);
            if (newOptionWeight > highestWeight){
                highestWeight = newOptionWeight;
                highestWeightedOption = options[i];
            }
          }
        }

        let maxSubscriptionPeriod = highestWeightedOption.attributes.agreementPeriod.value;
        let maxSubscriptionUnit = highestWeightedOption.attributes.agreementPeriodUnit.value;
        let highestOptionRate = highestWeightedOption.attributes.rate.value;

         this.state = {
            pkg: pkg,
            agreement: agreement,
            subscriptionPeriod: maxSubscriptionPeriod,
            subscriptionPeriodUnit: maxSubscriptionUnit,
            subscriptionRate: highestOptionRate,
            anyOngoingSubscription: anyOngoingSubscription,
            revPromoCode: null,
            autoRenew: (agreement != null)?agreement.attributes.autoRenew.value:false,
            promoCodeValue: null,
            acceptTermsAndConditions: null,
            acceptTermsAndConditionsError: null,
            loadPayment: null,
            performingPayment: false
        }
    }

//    toggleAgreementAutoRenewal(agreement){
//        if (!agreement){
//            return
//        }
//
//        const b2Event = {
//            type: 'toggleAgreementAutoRenewal',
//            eventDetails: {
//                beanId: this.props.bean.id,
//                customerAgreementId: agreement.attributes.customerAgreementId.value
//            }
//        }
//
//        this.props.processB2Event(b2Event);
//    }

    fetchPromoCode(){
        if (this.state.promoCodeValue == null || this.state.promoCodeValue === ''){
            this.setState({
                ...this.state,
                revPromoCode: null
            });
            return;
        }

        const b2Event = {
            type: 'fetchPromoCode',
            callback: this.applyPromoCode.bind(this),
            eventDetails: {
                beanId: this.props.bean.id,
                promoCodeId: this.state.promoCodeValue,
                packageName: this.state.pkg.attributes.packageName.value
            }
        }

        this.props.processB2Event(b2Event);
    }

    applyPromoCode(eventResponse){
        if (eventResponse.actionResponse.revPromoCode != null){
            this.setState({
                ...this.state,
                promoCodeValue: null,
                revPromoCode: eventResponse.actionResponse.revPromoCode
            });
        }else{
            this.setState({
                ...this.state,
                promoCodeValue: null
            });
        }
    }

    updatePromoValue = event => {
        event.stopPropagation();

        if (event.target.value && event.target.value.includes("\\")){
            return;
        }

        this.setState(
            {
                ...this.state,
                promoCodeValue: event.target.value
            }
        );
    };

    completePayment(token){
        const b2Event = {
            type: 'performPayment',
            callback: this.finalisePayment.bind(this),
            eventDetails: {
                beanId: this.props.bean.id,
                promoCodeId: (this.state.revPromoCode==null)?null:this.state.revPromoCode.attributes.id.value,
                packageName: this.state.pkg.attributes.packageName.value,
                subscriptionPeriod: this.state.subscriptionPeriod,
                subscriptionPeriodUnit: this.state.subscriptionPeriodUnit,
                promotion: this.state.promotion,
                action: (this.state.agreement!=null)?'RENEW':'CREATE',
                paymentSecret: token,
                autoRenew: this.state.autoRenew,
                agreementId: (this.state.agreement == null)?null:this.state.agreement.attributes.customerAgreementId.value
            }
        }

        this.props.processB2Event(b2Event);
    }

    finalisePayment(eventResponse){
        if (eventResponse.errors){
            this.setState (
                {
                   ...this.state,
                   loadPayment: null,
                   performingPayment: false
                }
            );
            return;
        }else{
             this.setState (
                {
                    pkg: null,
                    agreement: null,
                    anyOngoingSubscription: null,
                    subscriptionPeriod: null,
                    subscriptionPeriodUnit: null,
                    subscriptionRate: null,
                    revPromoCode: null,
                    autoRenew: null,
                    promoCodeValue: null,
                    promotion: null,
                    acceptTermsAndConditions: null,
                    acceptTermsAndConditionsError: null,
                    loadPayment: null,
                    performingPayment: false
                }
             );
        }
    }

    getRate() {
        let rate = 0.0;

        if (this.state.revPromoCode != null){
            if (this.state.revPromoCode.attributes.rate.value != null){
                if (this.state.revPromoCode.attributes.rateImpact.value === 'Amount'){
                    return this.state.subscriptionRate + this.state.revPromoCode.attributes.rate.value;
                }else{
                    return this.state.subscriptionRate + ((this.state.subscriptionRate * this.state.revPromoCode.attributes.rate.value)/100);
                }
            }
        }

        return this.state.subscriptionRate;
    }

    periodToText(periodUnit, period){
        if (periodUnit === 'Day'){

          if (this.state.revPromoCode != null && this.state.revPromoCode.attributes.period.value != null){
            if (this.state.revPromoCode.attributes.periodImpact.value === 'Amount'){
              if (this.state.revPromoCode.attributes.periodUnit === periodUnit){
                let periodVal = period + this.state.revPromoCode.attributes.period;
                if (periodVal % 7 === 0){
                    if ((periodVal / 7) === 2){
                        return "a fortnight";
                    }else{
                        return (periodVal/7) + " week" + ((periodVal==1)?'':'s');
                    }
                }else{
                    return period + " day" + ((period==1)?'':'s');
                }
              }else{
                return period + " days (Promo " + (period + this.state.revPromoCode.attributes.period.value) + " "+ this.state.revPromoCode.attributes.periodUnit.value + (this.state.revPromoCode.attributes.periodUnit.value==1?'':'s') + ")";
              }
            }else{
              return (period + (period * this.state.revPromoCode.attributes.period.value)/100) + " days";
            }
          }else {
            if (period % 7 === 0){
                if ((period / 7) === 2){
                    return "a fortnight";
                }else{
                    return (period/7) + " week" + (((period/7)==1)?'':'s');
                }
            }else{
                return period + " day" + ((period==1)?'':'s');
            }
          }
        }else if (periodUnit === 'Month'){
          if (this.state.revPromoCode != null && this.state.revPromoCode.attributes.period.value != null){
            if (this.state.revPromoCode.attributes.periodImpact.value === 'Amount'){
              if (this.state.revPromoCode.attributes.periodUnit.value === periodUnit){
                return (period + this.state.revPromoCode.attributes.period.value) + " months";
              }else{
                return period + " months (Promo " + (period + this.state.revPromoCode.attributes.period.value) + " "+ this.state.revPromoCode.attributes.periodUnit.value + (this.state.revPromoCode.attributes.periodUnit.value==1?'':'s') + ")";
              }
            }else{
              return (period + (period * this.state.revPromoCode.attributes.period.value)/100) + " months";
            }
          }else {
            return period + " month" + ((period==1)?'':'s');
          }
        }else{
          if (this.state.revPromoCode != null && this.state.revPromoCode.attributes.period.value != null){
            if (this.state.revPromoCode.attributes.periodImpact.value === 'Amount'){
              if (this.state.revPromoCode.attributes.periodUnit.value === periodUnit){
                return (period + this.state.revPromoCode.attributes.period.value) + " years";
              }else{
                return period + " years (Promo " + (period + this.state.revPromoCode.attributes.period.value) + " "+ this.state.revPromoCode.attributes.periodUnit.value + (this.state.revPromoCode.attributes.periodUnit.value==1?'':'s') + ")";
              }
            }else{
              return (period + (period * this.state.revPromoCode.attributes.period.value)/100) + " years";
            }
          }else {
            return period + " year" + ((period==1)?'':'s');
          }
        }
      }

    resendActivationLink = () => {
        const b2SecEvent = {
            type: RESEND_ACTIVE_LINK,
            eventDetails: {
            }
        }

        this.props.processB2SecurityEvent(b2SecEvent);
    }

    getNotActivatedCard() {
        return <React.Fragment>
                    <div key={this.props.uiDefinition.id+'_accountnotactivated_dev1'} id={this.props.uiDefinition.id+'_accountnotactivated_dev'} className="col-lg-4 col-12" style={{ padding: "0px 0px", minWidth: "305px"}}>
                    </div>
                    <div key={this.props.uiDefinition.id+'_accountnotactivated_dev2'} id={this.props.uiDefinition.id+'_accountnotactivated_dev2'} className="col-lg-4 col-12" style={{ padding: "0px 0px", minWidth: "305px"}}>
                        <CardBox styleName="col-ls-12" cardInlineStyle={{paddingTop: "10px", paddingLeft: "0px", paddingRight: "0px", minWidth: "330px", margin: "5px"}}>
                            <div className="row" noValidate autoComplete="off">

                               <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                  <div style={{
                                      margin : '30px 0px 5px 3px',
                                      width: '295px',
                                      display: 'inline-flex',
                                      verticalAlign: 'bottom',
                                      height: '1.0rem'
                                      }}>
                                        <div style={{fontWeight:'bold', fontStyle:'normal', width: '295px', textAlign: 'center', lineHeight: '20px', verticalAlign: 'bottom', paddingRight: '5px', fontSize: "1.2rem", height: '1.1rem', color: "red"}}>
                                          <span>Email not verified</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                      <div style={{
                                          margin : '30px 0px 5px 3px',
                                          width: '295px',
                                          display: 'inline-flex',
                                          verticalAlign: 'bottom',
                                          height: '6.0rem'
                                          }}>

                                             <div style={{fontWeight:'normal', fontStyle:'normal', width: '295px', textAlign: 'left', lineHeight: '20px', verticalAlign: 'bottom', paddingRight: '5px', fontSize: "1.2rem", height: '1.1rem', color: "#55739E"}}>
                                              <span>We need to make sure your email address is correct because tax receipts will be sent via email</span>
                                              <br/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                           <Chip label='Already Verified?'
                                            onClick={
                                                ()=>{this.alreadyActivatedEvent()}
                                            }
                                            className="mx-2" style={{width:'250px', fontSize: '0.9rem', margin : '7px 7px', backgroundColor: '#55739E', fontWeight: 'bold', color: 'white',}}/>
                                    </div>
                                <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                    <Chip label='Send Verification Message'
                                      onClick={
                                          ()=>{this.resendActivationLink()}
                                      }
                                      className="mx-2" style={{width:'250px', fontSize: '0.9rem', margin : '7px 7px', backgroundColor: '#55739E', fontWeight: 'bold', color: 'white',}}/>
                              </div>

                            </div>
                       </CardBox>
                    </div>
                <div key={this.props.uiDefinition.id+'_accountnotactivated_dev3'} id={this.props.uiDefinition.id+'_accountnotactivated_dev3'} className="col-lg-4 col-12" style={{ padding: "0px 0px", minWidth: "305px"}}>
           </div>
        </React.Fragment>
    }

    validateAgreement(agreement){
        if (!agreement){
            return false;
        }

        let endDate = new Date(agreement.attributes.endDate.value);

        if (endDate== null){
          return false;
        }

        let today = Date.now();

        if (endDate > today){ // today
          return true;
        }

        endDate = new Date(endDate.setDate(endDate.getDate() + 1));
        endDate.setHours(0,0,0,0);

        if (today < endDate){
            return true;
        }

        return false;
    }

    getOptionString(revPackageSubscriptionOption, agreement){
        if (revPackageSubscriptionOption == null){
            return ""
        }

        let period = revPackageSubscriptionOption.attributes.agreementPeriod.value;

        let periodUnit = revPackageSubscriptionOption.attributes.agreementPeriodUnit.value;

        let rate = revPackageSubscriptionOption.attributes.rate.value;

        if (periodUnit.toLowerCase () === 'day' && period === 14){
            return "1 Fortnight for $" + rate.toFixed(2);//  + " a fortnight";
        }else if (periodUnit.toLowerCase () === 'day' && period === 7){
            return "1 Week for $" + + rate.toFixed(2);// + " a week";
        }else if (periodUnit.toLowerCase () === 'day' && (period % 7) == 0){
            return (period/7) + " Week"+ (((period/7) === 1)?'':'s') + " for $" + (Math.ceil((   (rate/(period/7)) * 100).toFixed(3))/100).toFixed(2)  + " a week";
        }else if (periodUnit.toLowerCase() === 'day'){
             return period + " " + periodUnit + ((period===1)?'':'s') + " for $" + rate.toFixed(2);// + " a " + periodUnit.toLowerCase();
         }else if (period === 1){
            return period + " " + periodUnit + " for $" + rate.toFixed(2);// + " a " + periodUnit.toLowerCase();
        }else{
            return period + " " + periodUnit + "s for $" + (Math.ceil((   (rate/period) * 100).toFixed(3))/100).toFixed(2)  + " a " + periodUnit.toLowerCase();
        }
    }

    getOptionWeight(revPackageSubscriptionOption){
        if (revPackageSubscriptionOption.attributes.agreementPeriodUnit.value === 'Day'){
            return revPackageSubscriptionOption.attributes.agreementPeriod.value;
        }else if (revPackageSubscriptionOption.attributes.agreementPeriodUnit.value === 'Month'){
            return revPackageSubscriptionOption.attributes.agreementPeriod.value * 30.41;    //     365/12 so year would be after month
        }else{
            return revPackageSubscriptionOption.attributes.agreementPeriod.value * 365.25;
        }
    }

    getSubscriptionCard(){
        return (<div key={this.props.uiDefinition.id+'_subscription'} id={this.props.uiDefinition.id+'_subscription'} className="col-md-12 col-12" style={{ padding: "0px 0px", minWidth: "305px"}}>
                   <CardBox styleName="col-ls-12" cardInlineStyle={{paddingTop: "10px", paddingLeft: "0px", paddingRight: "0px", minWidth: "330px", margin: "5px"}}>
                       <div className="row" noValidate autoComplete="off">
                            <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                <div style={{
                                       margin: "15px 7px 0px 7px",
                                       width: '295px',
                                       display: 'inline',
                                       height: '5rem', lineHeight: '5rem',
                                       verticalAlign: 'middle',
                                       textAlign: 'left',
                                       fontSize: '1.5rem',
                                        color: '#55739E',
                                        height: '2.1rem'
                                   }}>
                                    <span>{this.state.pkg.attributes.packageName.value}</span>
                                </div>
                            </div>
                            <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                <div style={{
                                      margin : '7px 7px 0px 7px',
                                      fontWeight: 'bold',
                                      width: '295px',
                                      display: 'inline-grid',
                                      verticalAlign: 'middle',
                                      textAlign: 'left',
                                      paddingBottom : '10px',
                                      paddingTop : '10px'
                                      }}>
                                    <span>
                                        {
                                            (
                                            (this.state.agreement!=null)?
                                            ('Current expiry date will be extended by ' + this.periodToText(this.state.subscriptionPeriodUnit, this.state.subscriptionPeriod) + ((this.state.agreement.attributes.inTrial.value != null && this.state.agreement.attributes.inTrial.value )?'. You will not lose any trial period remaining':'')):
                                            (
                                                'New subscription to start today for ' + this.periodToText(this.state.subscriptionPeriodUnit, this.state.subscriptionPeriod) + (this.state.anyOngoingSubscription?". Existing subscription will cease and be replaced with the new one":'') + ((this.state.promotion != null)?". This is a one-time offer. It doesn't renew at same price if auto renewal is turned on":"")
                                            )
                                            )
                                        }
                                    </span>
                                </div>
                            </div>
                            {
                                (this.state.revPromoCode != null &&  this.state.revPromoCode.attributes && this.state.revPromoCode.attributes.userDescription && this.state.revPromoCode.attributes.userDescription.value && this.state.revPromoCode.attributes.userDescription.value !== '') &&
                                <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                    <div style={{
                                      margin : '0px 7px 0px 7px',
                                      fontWeight: 'bold',
                                      width: '295px',
                                      display: 'inline-grid',
                                      verticalAlign: 'middle',
                                      textAlign: 'left',
                                      paddingBottom : '10px'
                                      }}>
                                        <span>
                                            {this.state.revPromoCode.attributes.userDescription.value}
                                        </span>
                                    </div>
                                </div>
                            }
                            <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                <div style={{
                                  margin : '10px 7px 0px 7px',
                                  paddingBottom : '7px',
                                  paddingTop : '7px',
                                  fontWeight: 'bold',
                                  width: '295px',
                                  display: 'inline-flex',
                                  lineHeight: '20px',
                                  verticalAlign: 'top',
                                  textAlign: 'left',
                                  borderTop: '1px #D3D3D3 solid'
                                  }}>
                                  <div style={{ width: '140px', lineHeight: '20px', verticalAlign: 'top', paddingRight: '5px', color: '#55739E'}}>
                                      <span>Sale</span>
                                  </div>
                                  <div style={{ width: '155px', lineHeight: '20px', verticalAlign: 'top', paddingLeft: '5px'}}>
                                      <span>${this.getRate().toFixed(2) + ' ' + this.state.pkg.attributes.currency.value}</span>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                <div style={{
                                  margin : '10px 7px 0px 7px',
                                  paddingBottom : '7px',
                                  paddingTop : '7px',
                                  fontWeight: 'bold',
                                  width: '295px',
                                  display: 'inline-flex',
                                  lineHeight: '20px',
                                  verticalAlign: 'top',
                                  textAlign: 'left'
                                  }}>
                                  <div style={{ width: '140px', lineHeight: '20px', verticalAlign: 'top', paddingRight: '5px', color: '#55739E'}}>
                                      <span>GST {this.state.pkg.attributes.tax.value??0}%</span>
                                  </div>
                                  <div style={{ width: '155px', lineHeight: '20px', verticalAlign: 'top', paddingLeft: '5px'}}>
                                      <span>${(this.getRate() * ((this.state.pkg.attributes.tax.value??0) / 100)).toFixed(2) + ' ' + this.state.pkg.attributes.currency.value}</span>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                <div style={{
                                  margin : '10px 7px 0px 7px',
                                  paddingBottom : '7px',
                                  paddingTop : '7px',
                                  fontWeight: 'bold',
                                  width: '295px',
                                  display: 'inline-flex',
                                  lineHeight: '20px',
                                  verticalAlign: 'top',
                                  textAlign: 'left',
                                   borderBottom: '1px #D3D3D3 solid'
                                  }}>
                                  <div style={{ width: '140px', lineHeight: '20px', verticalAlign: 'top', paddingRight: '5px', color: '#55739E'}}>
                                      <span>Total</span>
                                  </div>
                                  <div style={{ width: '155px', lineHeight: '20px', verticalAlign: 'top', paddingLeft: '5px'}}>
                                      <span>${(this.getRate() + (this.getRate() * ((this.state.pkg.attributes.tax.value??0) / 100))).toFixed(2) + ' ' + this.state.pkg.attributes.currency.value}</span>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                <div style={{
                                    margin : '0px 7px 0px 7px',
                                    paddingBottom : '7px',
                                    paddingTop : '7px',
                                    fontWeight: 'bold',
                                    width: '295px',
                                    display: 'inline-flex',
                                    lineHeight: '20px',
                                    verticalAlign: 'top',
                                    textAlign: 'left'
                                    }}>
                                    <div style={{ width: '130px', lineHeight: '20px', verticalAlign: 'top', paddingRight: '5px', paddingTop: '10px', color: '#55739E'}}>
                                        <span>Auto Renewal</span>
                                    </div>
                                    <div style={{ width: '165px', lineHeight: '20px', verticalAlign: 'top', paddingLeft: '5px'}}>
                                        <Switch
                                          id={this.props.uiDefinition.id+'_subscription'+'_autorenewalswitch'}
                                          key={this.props.uiDefinition.id+'_subscription'+'_autorenewalswitch'}
                                          classes={{
                                              checked: 'text-primary',
                                              track:'bg-primary'
                                          }}
                                          disabled={this.state.performingPayment}
                                          checked={this.state.autoRenew}
                                          onChange={()=>this.setState(
                                                {
                                                    ...this.state,
                                                    autoRenew: !this.state.autoRenew
                                                }
                                            )
                                          }
                                         />
                                    </div>
                                </div>
                            </div>
                            {
                             (!this.state.revPromoCode && this.state.promotion == null) &&
                           <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                               <div style={{
                                   margin : '0px 7px 0px 7px',
                                   width: '295px',
                                   display: 'inline-flex',
                                   lineHeight: '20px',
                                   verticalAlign: 'top',
                                   textAlign: 'left'
                                   }}>
                                   <TextField
                                       InputProps={{
                                           endAdornment: <Chip label='Apply'
                                                onClick={(e) => this.fetchPromoCode(e)}
                                                 className="mx-2" style={{paddingRight: '0px', marginRight : '0px', backgroundColor: '#55739E', fontWeight: 'bold', color: 'white', width: '70px'}}/>,
                                           autoComplete:'off',
                                           form: {
                                               autocomplete: 'off',
                                           },
                                           style: {
                                            paddingRight: '0px',
                                            marginRight: '0px'
                                           }
                                       }}
                                       key={this.props.uiDefinition.id+"PhantomTextField"}
                                       style={
                                               {
                                                   "margin":"2px 2px 2px 0px"
                                               }
                                       }
                                       disabled={this.state.performingPayment}
                                       size="small"
                                       variant={"outlined"}
                                       margin="dense"
                                       placeholder="Enter Promo Code"
                                       fullWidth
                                       value={(this.state.promoCodeValue==null||this.state.promoCodeValue==='')?'':this.state.promoCodeValue}
                                       onChange={(e) => this.updatePromoValue(e)}
                                       onBlur={(e) => this.updatePromoValue(e)}
                                   />
                               </div>
                           </div>
                           }
                           {
                                (this.state.revPromoCode != null && this.state.promotion == null) &&
                               <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                   <div style={{
                                      margin : '0px 7px 0px 7px',
                                      paddingBottom : '7px',
                                      paddingTop : '7px',
                                      fontWeight: 'bold',
                                      width: '295px',
                                      display: 'inline-flex',
                                      lineHeight: '20px',
                                      verticalAlign: 'top',
                                      textAlign: 'left'
                                      }}>
                                      <div style={{ width: '140px', lineHeight: '20px', verticalAlign: 'top', paddingRight: '5px', color: '#55739E'}}>
                                          <span>Promo Code</span>
                                      </div>
                                      <div style={{ width: '155px', lineHeight: '20px', verticalAlign: 'top', paddingLeft: '5px'}}>
                                          <span>{this.state.revPromoCode.attributes.code.value}</span>
                                      </div>
                                   </div>
                               </div>
                           }

                           <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                               <div style={{
                                   margin : '0px 7px 0px 7px',
                                   fontWeight: 'bold',
                                   width: '295px',
                                   display: 'inline-flex',
                                   lineHeight: '20px',
                                   verticalAlign: 'top',
                                   textAlign: 'left'
                                   }}>
                                   <div style={{ width: '30px', lineHeight: '20px', verticalAlign: 'top', paddingRight: '5px', paddingTop: '15px'}}>
                                       <Checkbox color="primary"

                                           style={{"margin": "0px", "padding": "0px"}}
                                           checked={this.state.acceptTermsAndConditions == true}
//                                           onChange={
//                                                (e) => {
//                                                    this.setState(
//                                                        {
//                                                            ...this.state,
//                                                            acceptTermsAndConditions: ((this.state.acceptTermsAndConditions)?!this.state.acceptTermsAndConditions:true),
//                                                            acceptTermsAndConditionsError: (this.state.acceptTermsAndConditionsError && !this.state.acceptTermsAndConditions)?null:this.state.acceptTermsAndConditionsError
//                                                        }
//                                                    )
//                                                }
//                                           }
                                            onClick={
                                               (e) => {
                                                   this.setState(
                                                       {
                                                           ...this.state,
                                                           acceptTermsAndConditions: ((this.state.acceptTermsAndConditions)?!this.state.acceptTermsAndConditions:true),
                                                           acceptTermsAndConditionsError: (this.state.acceptTermsAndConditionsError && !this.state.acceptTermsAndConditions)?null:this.state.acceptTermsAndConditionsError
                                                       }
                                                   )
                                               }
                                            }
//                                            onKeyPress={
//                                                 (e) => {
//                                                     this.setState(
//                                                         {
//                                                             ...this.state,
//                                                             acceptTermsAndConditions: ((this.state.acceptTermsAndConditions)?!this.state.acceptTermsAndConditions:true),
//                                                             acceptTermsAndConditionsError: (this.state.acceptTermsAndConditionsError && !this.state.acceptTermsAndConditions)?null:this.state.acceptTermsAndConditionsError
//                                                         }
//                                                     )
//                                                 }
//                                            }
                                           disabled={this.state.performingPayment}
                                           value={(this.state.acceptTermsAndConditions)?this.state.acceptTermsAndConditions:false}
                                       />
                                  </div>
                                  <div style={{ width: '265px', lineHeight: '20px', verticalAlign: 'middle', paddingTop: '17px'}}>
                                    <span onClick={
                                             (e) => {
                                                 this.setState(
                                                     {
                                                         ...this.state,
                                                         acceptTermsAndConditions: ((this.state.acceptTermsAndConditions)?!this.state.acceptTermsAndConditions:true),
                                                         acceptTermsAndConditionsError: (this.state.acceptTermsAndConditionsError && !this.state.acceptTermsAndConditions)?null:this.state.acceptTermsAndConditionsError
                                                     }
                                                 )
                                             }
                                          }>Accept Terms & Conditions</span> - <span><Link to={{ pathname: config.termsAndConditions/*"https://safee.com.au/mobile-app-terms-and-conditions/"*/ }} target="_blank">View</Link></span>
                                  </div>
                               </div>
                           </div>
                           {
                                (this.state.acceptTermsAndConditionsError) &&
                               <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                   <div style={{
                                       margin : '0px 7px 0px 7px',
                                       width: '295px',
                                       display: 'inline-flex',
                                       lineHeight: '20px',
                                       verticalAlign: 'top',
                                       textAlign: 'left',
                                       color: 'red'
                                       }}>
                                       <span>Please read and accept Terms & Conditions</span>
                                   </div>
                               </div>
                           }
                           <div key={this.props.uiDefinition.id+'_subscription_buttons'} id={this.props.uiDefinition.id+'_subscription_buttons'} className="col-md-12 col-12" style={{textAlign: "center"}}>
                               <div style={{
                                   margin : '15px 7px 30px 7px',
                                   fontWeight: 'bold',
                                   borderRadius: '100em 100em 100em 100em',
                                   width: '295px',
                                   display: 'inline-flex',
                                   height: '20px', lineHeight: '20px',
                                   verticalAlign: 'middle'
                               }}>
                                    <div style={{width: '50%', textAlign: 'right', height: '20px', lineHeight: '20px', verticalAlign: 'middle', paddingRight: '5px'}}>
                                        <Chip label='Cancel'
                                            component={Link}
                                            to={"/"}
                                            className="mx-2" style={{fontSize: '0.9rem', margin : '12px 7px', backgroundColor: '#55739E', fontWeight: 'bold', color: 'white', width: '110px'}}/>
                                    </div>

                                    <div style={{width: '50%', textAlign: 'left', height: '20px', lineHeight: '20px', verticalAlign: 'middle', paddingLeft: '5px'}}>
                                        {
                                            (this.state.performingPayment) &&
                                             <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                                    <CircularProgress />
                                            </div>
                                        }
                                        {
                                            (!this.state.performingPayment) &&
                                             <Chip label={((this.getRate()==0 && this.state.agreement!=null)?'Renew':((this.getRate()==0 && this.state.agreement==null)?'Subscribe':'Proceed'))}
                                                 onClick={
                                                     ()=>{
                                                         if (!this.state.acceptTermsAndConditions){
                                                             this.setState(
                                                                 {
                                                                     ...this.state,
                                                                     acceptTermsAndConditionsError: true
                                                                 }
                                                             );
                                                             return;
                                                         }

                                                         if (this.getRate().toFixed(2) > 0){
                                                             const existingScript = document.getElementById('squareScript');
                                                             if (!existingScript) {
                                                                 const script = document.createElement('script');
                                                                 script.src = config.squareScript;//'https://sandbox.web.squarecdn.com/v1/square.js';
                                                                 script.id = 'squareScript';
                                                                 document.body.appendChild(script);
                                                                 script.onload = () => {
                                                                   this.setState(
                                                                       {
                                                                           ...this.state,
                                                                           loadPayment: true
                                                                       }
                                                                   )
                                                                 };
                                                             }else{
                                                                 this.setState(
                                                                     {
                                                                         ...this.state,
                                                                         loadPayment: true
                                                                     }
                                                                 )
                                                             }
                                                         }else{
                                                             this.setState(
                                                                  {
                                                                      ...this.state,
                                                                      performingPayment: true
                                                                  }
                                                             );
                                                             this.completePayment(null);
                                                         }
                                                     }
                                                 }
                                                 className="mx-2" style={{fontSize: '0.9rem', margin : '12px 7px', backgroundColor: '#55739E', fontWeight: 'bold', color: 'white', width: '110px'}}/>
                                        }
                                    </div>
                               </div>
                           </div>
                       </div>
                   </CardBox>
               </div>);
    }

    cancelPayment(){
       this.setState(
           {
               ...this.state,
               loadPayment: false
           }
       )
    }

    getPaymentResultCard(){

        let packages = [...this.props.datasources[this.props.beans[this.props.uiDefinition.offeringsDatasource].datasource].entityList.data[0].relationships['RevPackageNP'].data];

        let pkg = null;

        for (let tempPkg of packages){
            if (pkg == null){
                pkg = tempPkg;
            }else if ((tempPkg.attributes.packageWeight.value) > (pkg.attributes.packageWeight.value)){
                pkg = tempPkg;
            }
        }

        return (<div className="col-md-12 col-12" style={{ padding: "0px 0px", minWidth: "305px"}}>
                   <CardBox styleName="col-ls-12" cardInlineStyle={{paddingTop: "10px", paddingLeft: "0px", paddingRight: "0px", minWidth: "330px", margin: "5px"}}>
                       <div className="row" noValidate autoComplete="off">
                            <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                <div style={{
                                       margin: "15px 7px 0px 7px",
                                       width: '295px',
                                       display: 'inline',
                                       height: '5rem', lineHeight: '5rem',
                                       verticalAlign: 'middle',
                                       textAlign: 'left',
                                       fontSize: '1.5rem',
                                        color: '#55739E',
                                        height: '2.1rem'
                                   }}>
                                    {
                                        this.props.b2Message.message
                                    }
                                </div>
                            </div>
                          <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                             <div style={{
                                 margin : '5px 7px 30px 7px',
                                 fontWeight: 'bold',
                                 borderRadius: '100em 100em 100em 100em',
                                 width: '295px',
                                 display: 'inline-flex',
                                 height: '32px', lineHeight: '32px',
                                 verticalAlign: 'middle'
                             }}>
                                  <div style={{fontSize: '0.9rem', width: '100%', height: '20px', lineHeight: '20px', verticalAlign: 'middle'}}>
                                        <Chip label='Review My Subscription'
                                            component={Link}
                                            to='/app/b2/subscription'
                                            className="mx-2" style={{borderRadius: '100em', height: '32px', lineHeight: '32px', width: '210px', fontSize: '0.9rem', paddingLeft: '15px',  paddingRight: '15px', backgroundColor: '#55739E', fontWeight: 'bold', color: 'white', border: '0px'}}/>
                                    </div>

                             </div>
                         </div>
                        </div>
                    </CardBox>
                </div>);
    }

    render() {
        if (this.props.user.attributes.status.value.toLowerCase() === 'new'){
            return this.getNotActivatedCard();
        }else if (this.state.loadPayment){
            return (
                <SquarePayment
                    rate={this.getRate().toFixed(2)}
                    currency={this.state.pkg.attributes.currency.value}
                    packageName={this.state.pkg.attributes.packageName.value}
                    cancelPaymentFn={this.cancelPayment.bind(this)}
                    completePaymentFn={this.completePayment.bind(this)}
                    finalisePaymentFn={this.finalisePayment.bind(this)}
                ></SquarePayment>);
        }else if (this.state.pkg != null){
            return(
                <React.Fragment>
                    {this.getSubscriptionCard()}
                </React.Fragment>
            );
        }else if (this.props.b2Message){
            return(
                <React.Fragment>
                    {this.getPaymentResultCard()}
                </React.Fragment>
            );
        }else{
            return(
                <React.Fragment>
                    <CircularProgress />
                </React.Fragment>
            );
        }

    }
}

class SquarePayment extends React.Component {

    constructor(props) {
      super(props);
      // Don't call this.setState() here!
      this.state = { performingPayment: false };

    }

    static appId = config.appId;
    static locationId = config.locationId;

    async componentDidMount () {
        await this.initialiseSquare();
    }

    componentWillUnmount () {
        let allsuspects=document.getElementsByTagName("script");
        for (let i=allsuspects.length; i>=0; i--){
            if (allsuspects[i] && allsuspects[i].getAttribute("src")!==null && allsuspects[i].getAttribute("src").indexOf(this.scriptPath) !== -1 ){
                   allsuspects[i].parentNode.removeChild(allsuspects[i])
            }
        }
    }

    async initializeCard(payments) {
        const card = await payments.card();
        await card.attach('#card-container');

        return card;
    }

//    async createPayment(token) {
//        const body = JSON.stringify({
//          locationId: this.locationId,
//          sourceId: token,
//        });
//
//        const paymentResponse = await fetch('/payment', {
//          method: 'POST',
//          headers: {
//            'Content-Type': 'application/json',
//          },
//          body,
//        });
//
//        if (paymentResponse.ok) {
//          return paymentResponse.json();
//        }
//
//        const errorBody = await paymentResponse.text();
//        throw new Error(errorBody);
//    }

    async tokenize(paymentMethod) {
        const tokenResult = await paymentMethod.tokenize();
            if (tokenResult.status === 'OK') {
                return tokenResult.token;
            } else {
                let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
                if (tokenResult.errors) {
                    errorMessage += ` and errors: ${JSON.stringify(
                        tokenResult.errors
                    )}`;
            }

            throw new Error(errorMessage);
        }
    }

    displayLoadingError(error) {
        const statusContainer = document.getElementById(
          'payment-status-container'
        );

        if (statusContainer == null || typeof statusContainer === "undefined"){
            return;
        }

        statusContainer.style="margin: 7px 7px 0px 7px; font-weight: bold; width: 295px; display: inline; vertical-align: middle; text-align: center; font-size: 1.3rem; color: red";
        statusContainer.innerHTML = '<span>Unable to load payment form</span>';
    }

    displayPaymentError() {
        const statusContainer = document.getElementById(
          'payment-status-container'
        );

        if (statusContainer == null || typeof statusContainer === "undefined"){
            return;
        }

        statusContainer.style="margin: 7px 7px 0px 7px; font-weight: bold; width: 295px; display: inline; vertical-align: middle; text-align: center; font-size: 1.3rem; color: red";
        statusContainer.innerHTML = '<span>Unable to complete payment</span>';
    }

    async initialiseSquare () {
        if (!window.Square) {

            const cardButton = document.getElementById('card-container');

            this.displayLoadingError(new Error('Unable to build Square object'));
            return;

            //throw new Error('Square.js failed to load properly');
        }

        let payments;
        try {
            payments = window.Square.payments(SquarePayment.appId, SquarePayment.locationId);
        } catch (e) {
            this.displayLoadingError(e);
//            const statusContainer = document.getElementById(
//                'payment-status-container'
//            );
//            statusContainer.className = 'missing-credentials';
//            statusContainer.style.visibility = 'visible';
            return;
        }

        let card;
        try {
            card = await this.initializeCard(payments);
        } catch (e) {
            this.displayLoadingError(e);
            return;
        }

        // Checkpoint 2.

        const cardButton = document.getElementById('card-button');

        if (cardButton == null || typeof cardButton === "undefined"){
            return;
        }

        cardButton.addEventListener('click', async function (event) {
            event.preventDefault();
            if (!cardButton.disabled){
                cardButton.disabled = true;
                await this.handlePaymentMethodSubmission(event, card);
            }
        }.bind(this));
    }

    async handlePaymentMethodSubmission(event, paymentMethod) {

        try {
            // disable the submit button as we await tokenization and make a payment request.
            const token = await this.tokenize(paymentMethod);
            //const paymentResults = await this.createPayment(token);

            this.setState(
                {
                    ...this.state,
                    performingPayment: true
                }
            );

            this.props.completePaymentFn(token);
            //this.displayPaymentResults('SUCCESS');

        } catch (e) {
            const cardButton = document.getElementById('card-button');
            cardButton.disabled = false;
            //this.displayPaymentError();
            //this.displayPaymentResults('FAILURE');

        }
    }


    render() {
        return(
            <div className="col-md-12 col-12" style={{ padding: "0px 0px", minWidth: "305px"}}>
               <CardBox styleName="col-ls-12" cardInlineStyle={{paddingTop: "10px", paddingLeft: "0px", paddingRight: "0px", minWidth: "330px", margin: "5px"}}>
                   <div className="row" noValidate autoComplete="off">
                        <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                            <div style={{
                                   margin: "15px 7px 0px 7px",
                                   width: '295px',
                                   display: 'inline',
                                   height: '5rem', lineHeight: '5rem',
                                   verticalAlign: 'middle',
                                   textAlign: 'left',
                                   fontSize: '1.5rem',
                                    color: '#55739E',
                                    height: '2.1rem'
                               }}>
                                <span>{this.props.packageName}</span>
                            </div>
                        </div>
                        <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                            <div style={{
                                  margin : '7px 7px 0px 7px',
                                  fontWeight: 'bold',
                                  width: '295px',
                                  display: 'inline-grid',
                                  verticalAlign: 'middle',
                                  textAlign: 'left',
                                  paddingBottom : '20px',
                                  paddingTop : '10px'
                                  }}>
                                <span>
                                    {
                                        (!this.state.performingPayment)?
                                        'Please provide payment details in the below form':
                                        'Processing payment, please wait ...'
                                    }
                                </span>
                            </div>
                        </div>

                        {
                            (this.state.performingPayment) &&
                             <div className="col-md-12 col-12" style={{textAlign: "center", height: "100px"}}>
                                    <CircularProgress />
                            </div>
                        }
                        {
                            (!this.state.performingPayment) &&
                            <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                                <div style={{
                                      margin : '7px 7px 0px 7px',

                                      width: '295px',
                                      display: 'inline',

                                      verticalAlign: 'middle',
                                      textAlign: 'center'
                                      }}>
                                    <div id="card-container" style={{textAlign: "center", width: "330px", display: "inline-flex"}}></div>
                                </div>
                            </div>
                        }
                        <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                            <div>
                                <div id="payment-status-container"></div>
                            </div>
                        </div>
                      <div className="col-md-12 col-12" style={{textAlign: "center"}}>
                         <div style={{
                             margin : '5px 7px 30px 7px',
                             fontWeight: 'bold',
                             borderRadius: '100em 100em 100em 100em',
                             width: '295px',
                             display: 'inline-flex',
                             height: '32px', lineHeight: '32px',
                             verticalAlign: 'middle'
                         }}>
                              <div style={{width: '110px', fontSize: '0.9rem', width: '50%', textAlign: 'right', height: '20px', lineHeight: '20px', verticalAlign: 'middle', paddingRight: '5px'}}>
                              {
                                  (!this.state.performingPayment) &&
                                  <Chip label='Cancel'
                                      onClick={
                                        () => {
                                            if (this.state.performingPayment){
                                                return;
                                            }

                                            this.props.cancelPaymentFn()
                                        }
                                    }
                                      className="mx-2" style={{borderRadius: '100em', height: '32px', lineHeight: '32px', width: '110px', fontSize: '0.9rem', paddingLeft: '15px',  paddingRight: '15px', backgroundColor: '#55739E', fontWeight: 'bold', color: 'white', border: '0px'}}/>
                              }
                              </div>

                              <div style={{width: '50%', textAlign: 'left', height: '20px', lineHeight: '20px', verticalAlign: 'middle', paddingLeft: '5px'}}>
                              {
                                (!this.state.performingPayment) &&
                                  <button
                                      id="card-button"
                                      type="button"
                                      className="mx-2"
                                      style={{borderRadius: '100em', height: '32px', lineHeight: '32px', width: '110px', fontSize: '0.9rem', paddingLeft: '15px',  paddingRight: '15px', backgroundColor: '#55739E', fontWeight: 'bold', color: 'white', border: '0px'}}
                                      >Pay{/*' ' + this.props.rate + ' ' + this.props.currency*/}</button>
                              }
                              </div>

                         </div>
                     </div>
                    </div>
                </CardBox>
            </div>
        );
    }
}

export default SafeeApplyPromoCode;